import { useState } from 'react';
import { Helmet } from 'react-helmet-async';
import HeroSection from '@components/Home/HeroSection';
import Specialization from '@components/Home/Specialization';
import RecentProjects from '@components/Home/RecentProjects';
import ARVRSection from '@components/Home/ARVRSection';
import InteriorSection from '@components/Home/InteriorSection';
import VideoCarousel from '@components/Home/VideoCarousel';
import Testimonials from '@components/Common/Testimonials';
import ContactCTA from '@components/Home/ContactCTA';
import ContactModal from '@components/Common/ContactModal';

const Home = () => {
    const [isModalOpen, setIsModalOpen] = useState(false);

    return (
        <>
            <Helmet>
                <title>Home - Abhishek Tamakuwala Architects</title>
                <meta name="description" content="Welcome to Abhishek Tamakuwala Architects - Creating architectural marvels in Surat" />
            </Helmet>

            {/* 1. Welcome Section */}
            <HeroSection />

            {/* 2. Our Specialization */}
            <Specialization />

            {/* 3. Recent Projects (Architectural) */}
            <RecentProjects />

            {/* 4. Future Visions (AR/VR) */}
            <ARVRSection />

            {/* 5. Interior Section */}
            <InteriorSection />

            {/* 6. Video Section */}
            <VideoCarousel />

            {/* 7. Testimonials */}
            <Testimonials />

            {/* 8. Contact CTA + Modal */}
            <ContactCTA onOpenModal={() => setIsModalOpen(true)} />
            <ContactModal
                isOpen={isModalOpen}
                onClose={() => setIsModalOpen(false)}
            />
        </>
    );
};

export default Home;
